<template>
    <section id="invitation">
    <h3 class="name">
        <span class="desktop-name">Angela Grace Clarke</span>
        <span class="mobile-name">Angela Clarke</span>
    </h3>
    <h5 style="font-weight: 400;">and</h5>
    <h3 class="name">
        <span class="desktop-name">James Andrew Cadle Thomson</span>
        <span class="mobile-name">James Thomson</span>
    </h3>
    <h5  style="font-weight: 400;">invite you to celebrate their marriage</h5>
    <div class="info">
        <div class="info-column left">
            <p>Saturday</p>
            <p>17 January 2026</p>
            <p>at 3 pm</p>
        </div>
        <div class="info-column right">
            <p>Forest Chapel</p>
            <p>Providence Country Estate</p>
            <p>Nottingham Road</p>
        </div>
    </div>
    <p class="reception">Canap&eacute;s and reception to follow</p>
</section>
</template>

<script>
export default {
    name: "InvitationSection",
}
</script>

<style scoped>
.name {
    font-family: "Exmouth", serif;
    font-size: 3rem;
    font-weight: 400;
    margin-bottom: 0.5rem;
}

/* Desktop names - show full names */
.desktop-name {
    display: inline;
}

.mobile-name {
    display: none;
}

/* Mobile names - show only first and last names */
@media (max-width: 768px) {
    .desktop-name {
        display: none;
    }

    .mobile-name {
        display: inline;
    }
}

.info {
    display: flex;
    margin-top: 2rem;
}

.info-column {
    display: flex;
    flex-direction: column;
}



.info-column.left {
    align-items: flex-end;
    padding-right: 1rem;
    border-right: 1px solid #000;
    width: 50%;
    text-align: right;
}

.info-column.right {
    align-items: flex-start;
    padding-left: 1rem;
    width: 50%;
    text-align: left;
}

/* Mobile responsive adjustments */
@media (max-width: 768px) {
    .info-column.left {
        width: 37% !important;
    }

    .info-column.right {
        width: 63% !important;
    }
}

.reception {
    margin-top: 1rem;
    text-align: center;
}


</style>